// tslint:disable-next-line:no-var-requires
const StoryblokClient = require('storyblok-js-client');
import { get } from './config'
import { ITouristContent } from '../pages/TouristPage'

interface IStoryblokResponseCollection {
    welcomeContent: any
    thankYouContent: any
    touristContent?: ITouristContent
    termsAndConditions: any
    privacyPolicy: any
    theme: {
        colors: any
        logo: any
        fonts: IStoryblokFont
    }
}

interface IStoryblokFont{
    light: string
    regular: string
    medium: string
    bold: string
    tourismCta?: string
    tourismBody?: string
}

const storyBlokClient = new StoryblokClient({
    accessToken: get('storyblokAccessToken'),
    cache: {
        clear: 'auto',
        type: 'memory'
    }
})

const getStoryblokData = async (locale: string): Promise<IStoryblokResponseCollection> => {
    let startsWith = 'channels/digital-passport/concierge/concierge-content'
    let tourismStartsWith = 'channels/digital-passport/tourist/tourist-welcome'
    if(locale !== 'en-au') {
        startsWith = locale + '/' + startsWith
        tourismStartsWith = locale + '/' + tourismStartsWith
    }

    const [data, tourismData] = await Promise.all([
        storyBlokClient.get('cdn/stories', {
            starts_with: startsWith,
            resolve_relations: 'theme'
        }),
        storyBlokClient.get('cdn/stories', {
            starts_with: tourismStartsWith,
            resolve_relations: 'theme'
        })
    ])
    const conciergeContent = data.data.stories[0].content
    const theme = conciergeContent.theme.content
    const touristContent = tourismData.data.stories[0].content

    return {
        welcomeContent: conciergeContent.welcome_page[0],
        thankYouContent: conciergeContent.thank_you_page[0],
        touristContent: touristContent,
        termsAndConditions: conciergeContent.terms_and_conditions[0],
        privacyPolicy: conciergeContent.privacy_policy[0],
        theme: {
            colors: JSON.parse(theme.colors),
            logo: theme.centreLogoSecondary,
            fonts: {
                light: theme.fonts && theme.fonts.length > 0 && `https:${theme.fonts[0].filename}` || '',
                regular: theme.fonts && theme.fonts.length > 0 && `https:${theme.fonts[1].filename}` || '',
                medium: theme.fonts && theme.fonts.length > 0  && `https:${theme.fonts[2].filename}` || '',
                bold: theme.fonts && theme.fonts.length > 0  && `https:${theme.fonts[3].filename}` || '',
                tourismCta: touristContent.theme && touristContent.theme.content && `https:${touristContent.theme.content.Font}`,
                tourismBody: touristContent.theme && touristContent.theme.content && `https:${touristContent.theme.content.Site_body_font}`
            }
        }
    }
}

const getTourismContent = async (startsWith: string) => {
    const data = await storyBlokClient.get('cdn/stories', {
        starts_with: startsWith,
        resolve_relations: 'theme'
    })
    return data.data.stories[0].content
}


export { getStoryblokData, IStoryblokResponseCollection, getTourismContent }



// WEBPACK FOOTER //
// ./src/lib/storyblok.tsx